/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { Territory } from 'types';

const find = async (): Promise<Territory[]> => {
  const response = await callLiferayEndpoint('/protones-portlet.territori/find-all', {});
  return response.map(utils.toTerritory);
};

export default {
  find,
};
